<template>
  <div>
    <b-modal
      :id="modalId"
      :title="modalTitle"
      no-close-on-backdrop
      size="xl"
      @shown="init"
      @hidden="hideModal"
    >
      <name-input
        :all-des="allDes"
        :is-ready="fieldsReady"
        :outer-container-class="'m-items'"
        :label-class="'label'"
        :value-container-class="'expression'"
        :name="de.name"
        :de-id="de.id"
        @on-name-input-changed="onDeNameChanged"
      ></name-input>

      <element-description
        v-if="fieldsReady"
        :elem-description="de.description"
        :outer-container-class="'m-items'"
        :label-class="'label'"
        :value-container-class="'expression'"
        @on-element-description-changed="onDeDescriptionChanged"
      ></element-description>

      <div class="m-items" v-if="fieldsReady">
        <div class="label-wrapper">
          <div class="label">
            {{ $t("default") }}
          </div>
        </div>
        <div class="expression">
          <expressions
            :id="'datepicker-id-' + de.id"
            :data-elements="allSources"
            :selected-source="selectedSource"
            :data-type="'date'"
            :initial-expression="defaultDateExpression"
            :is-global="true"
            :content-type="$attrs.appType"
            @on-expression-field-valid="onDefaultDateConfigValid"
          />
        </div>
      </div>

      <template v-slot:modal-footer>
        <button
          class="modal-btn no-user-select modal-cancel-btn"
          @click="hideModal()"
        >
          {{ cancelText }}
        </button>
        <button
          class="modal-btn no-user-select modal-save-btn"
          :disabled="isDisabled"
          @click="finishQuery()"
        >
          {{ okText }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Expressions from "@/components/Expressions"
import {mapState} from "vuex";
import {DATA_ELEMENT_TYPE} from "@/static/global-variables";
import store from "@/store";
import {MUTATION_NAME} from "@/static/global-variables";
import NameInput from "@/components/NameInput";
import ElementDescription from "@/components/ElementDescription";

export default {
  name: "DatepickerEditModal",
  components: {
    Expressions,
    NameInput,
    ElementDescription
  },
  props: {
    appId: String,
    de: Object,
    id: String,
    name: String,
    allDes: Object
  },
  data() {
    return {
      deName: null,
      isNameValid: false,
      deClone: null,
      deDescription: null,
      defaultDateExpression: null,
      fieldsReady: false
    }
  },
  computed: {
    ...mapState({
      messages: "messages"
    }),
    cancelText() {
      return this.getMessageText(this.messages.CANCEL);
    },
    okText() {
      return this.getMessageText(this.messages.OK);
    },
    modalId() {
      return `datepicker-edit-modal_${this.de.id}`;
    },
    modalTitle() {
      return `${this.getMessageText(
        this.messages.Edit
      )} ${this.$t("datepickerData")}`;
    },
    allSources() {
      return JSON.parse(JSON.stringify(this.allDes));
    },
    selectedSource() {
      return JSON.parse(JSON.stringify(this.de));
    },
    isDisabled() {
      return !this.isNameValid || !this.deName;
    },
  },
  methods: {
    hideModal() {
      this.fieldsReady = false;
      this.$bvModal.hide(this.modalId);
    },
    finishQuery() {
      const deInfo = {
        appId: this.appId,
        de: {
          id: this.de.id,
          displayElementRefCount: this.de.displayElementRefCount,
          description: this.deDescription,
          name: this.deName,
          fields: { Selection: { dataType: "Date" } },
          type: DATA_ELEMENT_TYPE.DATEPICKER,
          default: this.defaultDateExpression,
        }
      };

      store.commit(MUTATION_NAME.UPDATE_DE_QUERY, deInfo);
      this.$bvModal.hide(this.modalId);
    },
    init() {
      let component = this;
      this.deClone = JSON.parse(JSON.stringify(component.de));
      this.deDescription = this.de.description;

      this.deName = this.de.name;
      this.defaultDateExpression = this.deClone.default;
      this.fieldsReady = true;
    },
    onDefaultDateConfigValid(ctx) {
      const expValue = ctx.status ? ctx : null;
      this.defaultDateExpression = expValue ? expValue.confExpression : null;
    },
    onDeNameChanged(isValidName, nameInput) {
      this.deName = nameInput;
      this.isNameValid = isValidName;
    },
    onDeDescriptionChanged(input) {
      this.deDescription = input;
    }
  }
}
</script>

<style scoped lang="scss">
.m-items {
  min-width: 45rem;
  grid-template-columns: 8rem auto;
  margin-bottom: 10px;
  color: var(--DEFAULT_TEXT_BLACK);
  .label {
    overflow-wrap: anywhere;
    padding-top: 0.3rem;
  }
  .label-wrapper {
    padding-right: 1rem;
  }
  .expression,
  .label {
    display: flex;
    align-items: center;
    min-height: 2.5rem;
  }
  .progress-overflow {
    padding-top: 0;
  }
}
.m-title {
  text-align: left;
}
</style>
